import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from './modules/i18n';

import { locale as esLang } from './modules/i18n/lang/es-ES';
import { AuthService } from './modules/auth/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'incroco';

  constructor(
    private translationService: TranslationService){}

  ngOnInit(): void {
    this.translationService.loadTranslations(esLang);
  }

  
}
